<div class="wrapper__headerComponent container my-5">
  <div class="row align-items-center">
    <div class="col-12 col-md-3"></div>
    <div class="col-12 col-md-6">
      <h2 class="text-center h3-tipografia-govco mb-0">
        {{"gestion-expediente-segunda-instancia" | translate}}
      </h2>
    </div>
  </div>
</div>
<div class="wrapper__contentComponent--expediente container my-5">
  <div class="contenedor-tabla w-100">
      <app-table
      id="historico"
      (evento)="buscar($event)"
      [datos]="expedientesSegundaInstancia"
      [paginaActual]="paginaActual"
      [columnas]="columns"
      [paginacion]="true"
      [tamano]="tamanoPagina"
      [totalPaginas]="totalPaginas"
      [tamanos]="[1, 5, 10, 20]"></app-table>
  </div>
</div>
<div class="container my-5">
  <div class="row align-items-center container-status mb-4">
    <div class="col cards-status">
      <p><strong>{{"expediente-segunda-instancia.enviados" | translate}}</strong></p>
      <p>{{expedientesEnviados}}</p>
    </div>
    <div class="col cards-status">
      <p><strong>{{"expediente-segunda-instancia.preparacion" | translate}}</strong></p>
      <p>{{expedientesEnPreparacion}}</p>
    </div>
    <div class="col cards-status">
      <p><strong>{{"expediente-segunda-instancia.acuse" | translate}}</strong></p>
      <p>{{expedientesAcuse}}</p>
    </div>
    <div class="col cards-status">
      <p><strong>{{"expediente-segunda-instancia.atencion" | translate}}</strong></p>
      <p>{{expedientesEFJE}}</p>
    </div>
    <div class="col cards-status">
      <p><strong>{{"expediente-segunda-instancia.radicado" | translate}}</strong></p>
      <p>{{expedientesRadicadoSegundaInstancia}}</p>
    </div>
  </div>
</div>
<app-politica-tratamiento-datos-personales></app-politica-tratamiento-datos-personales>
